/* eslint-disable no-unsafe-optional-chaining */
import React, { useCallback, useEffect, useRef, useState } from "react";
import MainFooterComponent from "common/components/MainFooterComponent/MainFooterComponent";

import "./ByHandExercise.scss";

// import images
import DeffenceScreenClubCard from "assets/images/DeffenceScreenClubCard.png";
import DeffenceScreenHeartCard from "assets/images/DeffenceScreenHeartCard.png";
import { useTypedDispatch } from "store";
import {
  getCoursesHandPlay,
  getCoursesTricksPlay,
  getCoursesMinibridge
} from "store/game/thunkActions";
import { setGameMultiple } from "store/game/slice";
import {
  getExerciseByCourceHandPlay,
  getExerciseByCourceTrickPlay,
  getExerciseByCourceMiniBridge
} from "store/users/thunkActions";
import { useNavigate, useSearchParams } from "react-router-dom";
import { setSimpleField } from "store/users/slice";
import GameHeader from "common/components/GameHeader/GameHeader";
import { useQuery } from "hooks/useQuery";
import TabsCourses from "features/game/components/TabsCourses";
import HeaderFilterCourses from "common/components/HeaderFilterCourses";
import MainPageHeaderMobile from "common/components/MainPageHeader/MainPageHeaderMobile";
import { showMobile } from "helpers/adaptation";
import { basicPrepareRouteToGame } from "common/helpers/routeToGame";

function ByHandPlayExercise() {
  const dispatch = useTypedDispatch();
  const [dataHandPlay, setDataHandPlay] = useState<any[]>([]);
  const [dataTricks, setDataTricks] = useState<any[]>([]);
  const [dataMinibridge, setDataMinibridge] = useState<any[]>([]);

  const navigate = useNavigate();
  const params = useQuery();
  const [keyTab, setKeyTab] = useState(params?.get("type") === "handPlay" ? "handPlay" : "tricks");
  const [searchRes, setSearchRes] = useState<any[]>([]);
  const [search, setSearch] = useState("");
  const data1LevelsApplied = useRef(false);
  const data2LevelsApplied = useRef(false);
  const dataTricksLevelsApplied = useRef(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [expireModal, setExpireModal] = useState(false);

  useEffect(() => {
    const type = searchParams.get("type");
    if (type === "handPlay" || type === "tricks" || type === "practice" || type === "miniBridge") {
      setKeyTab(type);
    }
  }, [searchParams]);

  useEffect(() => {
    const getData = async () => {
      if (keyTab === "handPlay" && !dataHandPlay.length) {
        try {
          const res: any = await dispatch(getCoursesHandPlay());
          setDataHandPlay(
            res?.Results?.map((val: any) => {
              return {
                Data: {
                  ...val?.Data,
                  CourseTitle: `${val?.Data?.CatTitle1} ${val?.Data?.CatTitle2}`
                }
              };
            })
          );
        } catch {
          //
        }
      }
      if (keyTab === "tricks" && !dataTricks.length) {
        try {
          const res: any = await dispatch(getCoursesTricksPlay());
          const arrBoof: any[] = [];

          res?.Results?.forEach((val: any) => {
            val?.Column?.map((item: any) => {
              arrBoof.push(item);
            });
          });
          setDataTricks(arrBoof);
        } catch {
          //
        }
      }
      if (keyTab === "miniBridge" && !dataMinibridge.length) {
        try {
          const res: any = await dispatch(getCoursesMinibridge());
          setDataMinibridge(
            res?.Results?.map((val: any) => {
              return {
                Data: {
                  ...val?.Data,
                  CourseTitle: `${val?.Data?.CatTitle1} ${val?.Data?.CatTitle2}`
                }
              };
            })
          );
        } catch {
          //
        }
      }
    };
    getData();
  }, [dataHandPlay.length, dataTricks.length, dataMinibridge.length, dispatch, keyTab]);

  const [data1, setData1] = useState<any[]>([]);
  const [data2, setData2] = useState<any[]>([]);

  useEffect(() => {
    if (Array.isArray(dataHandPlay) && dataHandPlay.length > 0) {
      const columnGroups: { [key: number]: any[] } = { 1: [], 2: [], 3: [] };

      const sorted = [...dataHandPlay].sort(
        (a: any, b: any) => (a?.Data?.CategoryIndex || 0) - (b?.Data?.CategoryIndex || 0)
      );

      sorted.forEach((val) => {
        if (val) {
          const colIndex = val?.Data?.PageColumn || 1;
          if (colIndex >= 1 && colIndex <= 3) {
            columnGroups[colIndex].push(val);
          }
        }
      });

      const maxRows = Math.max(
        columnGroups[1].length,
        columnGroups[2].length,
        columnGroups[3].length
      );

      const boofer: any[] = Array.from({ length: maxRows }, (_, rowIndex) => [
        columnGroups[1][rowIndex] || null,
        columnGroups[2][rowIndex] || null,
        columnGroups[3][rowIndex] || null
      ]);

      setData1(boofer);
    } else {
      // setData1([]);
    }
  }, [dataHandPlay]);

  useEffect(() => {
    if (Array.isArray(dataMinibridge) && dataMinibridge.length > 0) {
      const columnGroups: { [key: number]: any[] } = { 1: [], 2: [], 3: [] };

      dataMinibridge.forEach((val) => {
        if (val) {
          const colIndex = val?.Data?.PageColumn || 1;
          if (colIndex >= 1 && colIndex <= 3) {
            columnGroups[colIndex].push(val);
          }
        }
      });

      const maxRows = Math.max(
        columnGroups[1].length,
        columnGroups[2].length,
        columnGroups[3].length
      );

      const boofer: any[] = Array.from({ length: maxRows }, (_, rowIndex) => [
        columnGroups[1][rowIndex] || null,
        columnGroups[2][rowIndex] || null,
        columnGroups[3][rowIndex] || null
      ]);

      setData2(boofer);
    } else {
      // setData2([]);
    }
  }, [dataMinibridge]);

  const onPressHandPlay = useCallback(
    async (val: any) => {
      try {
        const res: any = await dispatch(getExerciseByCourceHandPlay(val?.Data?.Id_Category));

        const { gameId, arrResult } = basicPrepareRouteToGame("hand_play", res, dispatch);

        const data = {
          gameId,
          courseId: arrResult[0]?.Data?.CategoryId,
          gameName: val?.Data?.CourseTitle,
          globalGameId: arrResult[0]?.Data?.Id_PHExercise
        };
        dispatch(
          setGameMultiple({
            type_game: "handPlay",
            data: {}
          })
        );
        localStorage.setItem("hand_play_exercise", JSON.stringify(data));

        dispatch(
          setGameMultiple({
            type_game: "handPlay",
            data
          })
        );
        navigate("/hand_play");
      } catch {
        //
      } finally {
        dispatch(setSimpleField({ type: "isLoading", value: false }));
      }
    },
    [dispatch, navigate]
  );

  const onPressTricksPlay = useCallback(
    async (val: any) => {
      try {
        const res: any = await dispatch(getExerciseByCourceTrickPlay(val?.CourseId));
        const { findItem } = basicPrepareRouteToGame("tricks", res, dispatch);

        const data = {
          gameId: findItem?.Data?.ExIndex,
          courseId: val?.CourseId,
          gameName: `${val?.Title1} ${val?.Title2}`
        };

        localStorage.setItem("tricks_exercise", JSON.stringify(data));

        dispatch(
          setGameMultiple({
            type_game: "tricks",
            data: {
              gameId: findItem?.Data?.ExIndex,
              courseId: val?.CourseId,
              globalGameId: findItem?.Data?.ExIndex,
              gameName: `${val?.Title1} ${val?.Title2}`
            }
          })
        );

        navigate("/tricks_play");
      } catch {
        //
      } finally {
        dispatch(setSimpleField({ type: "isLoading", value: false }));
      }
    },
    [dispatch, navigate]
  );

  const onPressMiniBridge = useCallback(
    async (val: any) => {
      try {
        const res: any = await dispatch(getExerciseByCourceMiniBridge(val?.Data?.Id_Category));

        if (!res?.Results?.length) return;

        const arrResult = [...res.Results].sort(
          (a: any, b: any) => a?.Data?.ExIndex - b?.Data?.ExIndex
        );
        const firstExercise = arrResult[0]?.Data;

        const data = {
          gameId: firstExercise?.ExIndex,
          courseId: firstExercise?.CategoryId,
          gameName: val?.Data?.CourseTitle,
          gameTitle: val?.Data?.CourseTitle,
          globalGameId: firstExercise?.Id_MiniBridgeExercise
        };

        dispatch(
          setGameMultiple({
            type_game: "mini_bridge",
            data: {}
          })
        );
        localStorage.setItem("mini_bridge_exercise", JSON.stringify(data));

        dispatch(
          setGameMultiple({
            type_game: "mini_bridge",
            data
          })
        );
        navigate("/mini_bridge");
      } catch {
        //
      } finally {
        dispatch(setSimpleField({ type: "isLoading", value: false }));
      }
    },
    [dispatch, navigate]
  );

  const onSearch = useCallback(
    (text: string) => {
      setSearch(text);
      if (text === "") {
        return setSearchRes([]);
      }
      const boofer: any[] = [];
      const addedIds = new Set();
      const searchLower = text.toLowerCase();

      if (keyTab === "tricks") {
        dataTricks?.forEach((val: any) => {
          const titleMatch =
            `${val?.Title1 || ""} ${val?.Title2 || ""}`?.toLowerCase()?.indexOf(searchLower) !== -1;
          const tagsMatch = val?.Tags?.toLowerCase()?.indexOf(searchLower) !== -1;

          if (titleMatch || tagsMatch) {
            const itemId = val?.CourseId || val?.Title1;
            if (!addedIds.has(itemId)) {
              addedIds.add(itemId);
              boofer.push({
                ...val,
                CatTitle1: val?.Title1,
                CatTitle2: val?.Title2
              });
            }
          }
        });
        setSearchRes(boofer);
      } else if (keyTab === "miniBridge") {
        data2?.forEach((val: any) => {
          if (val?.length > 0) {
            val.forEach((item: any) => {
              if (item && item.Data?.CourseTitle) {
                const titleMatch = item.Data.CourseTitle.toLowerCase().indexOf(searchLower) !== -1;
                const tagsMatch = item.Data?.Tags?.toLowerCase()?.indexOf(searchLower) !== -1;

                if (titleMatch || tagsMatch) {
                  const itemId = item?.Data?.CourseId || item?.Data?.CourseTitle;
                  if (!addedIds.has(itemId)) {
                    addedIds.add(itemId);
                    boofer.push({
                      ...item,
                      CatTitle1: item.Data.CatTitle1,
                      CatTitle2: item.Data.CatTitle2
                    });
                  }
                }
              }
            });
          }
        });
        setSearchRes(boofer);
      } else {
        data1?.forEach((val: any) => {
          if (val?.length > 0) {
            val.forEach((item: any) => {
              if (item && item.Data?.CourseTitle) {
                const titleMatch = item.Data.CourseTitle.toLowerCase().indexOf(searchLower) !== -1;
                const tagsMatch = item.Data?.Tags?.toLowerCase()?.indexOf(searchLower) !== -1;

                if (titleMatch || tagsMatch) {
                  const itemId = item?.Data?.CourseId || item?.Data?.CourseTitle;
                  if (!addedIds.has(itemId)) {
                    addedIds.add(itemId);
                    boofer.push({
                      ...item,
                      CatTitle1: item.Data.CatTitle1,
                      CatTitle2: item.Data.CatTitle2
                    });
                  }
                }
              }
            });
          }
        });
        setSearchRes(boofer);
      }
    },
    [data1, data2, dataTricks, keyTab]
  );

  const onHandleChangeLevel = (val: any) => {
    const audit: number[] = [];
    if (val?.ease) audit.push(10);
    if (val?.medium) audit.push(20);
    if (val?.hard) audit.push(30);

    const checkLevel = (levels: string, audit: number[]) =>
      audit.some((lvl) => levels?.split("_")?.includes(String(lvl)));

    const markIsEnabled = (item: any) => ({
      ...item,
      isEnabled: !audit.length || checkLevel(item?.Data?.Levels || item?.Levels, audit)
    });

    if (data1.length) {
      const updated = data1.map((row: any[]) =>
        row?.map((item) => (item ? markIsEnabled(item) : null))
      );
      setData1(updated);
    }

    if (data2.length) {
      const updated = data2.map((row: any[]) =>
        row?.map((item) => (item ? markIsEnabled(item) : null))
      );
      setData2(updated);
    }

    if (dataTricks.length) {
      const updated = dataTricks.map((item) => (item ? markIsEnabled(item) : null));
      setDataTricks(updated);
    }

    if (searchRes.length) {
      const updated = searchRes.map((item) => (item ? markIsEnabled(item) : null));
      setSearchRes(updated);
    }
  };

  useEffect(() => {
    if (data1.length > 0 && !data1LevelsApplied.current) {
      data1LevelsApplied.current = true;
      const resLevels = localStorage.getItem("levels");
      if (resLevels) {
        onHandleChangeLevel(JSON.parse(resLevels));
      } else {
        onHandleChangeLevel({});
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data1]);

  useEffect(() => {
    if (data2.length > 0 && !data2LevelsApplied.current) {
      data2LevelsApplied.current = true;
      const resLevels = localStorage.getItem("levels");
      if (resLevels) {
        onHandleChangeLevel(JSON.parse(resLevels));
      } else {
        onHandleChangeLevel({});
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data2]);

  useEffect(() => {
    if (dataTricks.length > 0 && !dataTricksLevelsApplied.current) {
      dataTricksLevelsApplied.current = true;
      const resLevels = localStorage.getItem("levels");
      if (resLevels) {
        onHandleChangeLevel(JSON.parse(resLevels));
      } else {
        onHandleChangeLevel({});
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataTricks]);

  return (
    <div className="ByHandExercise-screen-wrapper">
      {!showMobile && <GameHeader />}
      {showMobile && <MainPageHeaderMobile showGameMenu />}
      <div className="ByHandExercise-statement-wrapper">
        <HeaderFilterCourses
          title="משחק יד"
          type={keyTab === "tricks" ? "tricks" : "handPlay"}
          onChangeText={onSearch}
          value={search}
          onHandleChangeLevel={onHandleChangeLevel}
          onExpireModal={() => setExpireModal(true)}
        />
        <div
          className={`ByHandExercise-Tabs-main ${
            keyTab === "handPlay" ? "tabs-wrapper-first-element" : ""
          } ${keyTab === "practice" ? "tabs-wrapper-hide-scroll" : ""}`}>
          <TabsCourses
            keyTab={keyTab}
            isExpired={expireModal}
            onExpiredClose={() => setExpireModal(false)}
            onSelect={(k: any) => {
              setKeyTab(k);
              setSearchParams(`type=${k}`);
              setSearch("");
              setSearchRes([]);
              const myDiv = document.getElementsByClassName("PracticeByCoursesTab-main");
              const myTechnique = document.getElementsByClassName("PracticeByTechniqueTab-main");

              if (myDiv && myDiv.length) {
                for (let i = 0; i <= myDiv.length; i++) {
                  myDiv[i]?.scrollTo({ top: 0 });
                }
              }
              if (myTechnique && myTechnique.length) {
                for (let i = 0; i <= myTechnique.length; i++) {
                  myTechnique[i]?.scrollTo({ top: 0 });
                }
              }
            }}
            onPressTricksPlay={onPressTricksPlay}
            onPressHandPlay={onPressHandPlay}
            onPressMiniBridge={onPressMiniBridge}
            dataAllCourses={{
              handPlay: search.length > 0 && keyTab === "handPlay" ? searchRes : data1,
              practice: [],
              tricks: search.length > 0 && keyTab === "tricks" ? searchRes : dataTricks,
              miniBridge: search.length > 0 && keyTab === "miniBridge" ? searchRes : data2
            }}
            searchRes={searchRes}
            search={search}
            type="handPlay_tricks"
            listTitle={{
              tricks: "תרגול לקיחות",
              handPlay: "תרגול לפי קורסים",
              practice: "תרגול לפי טכניקה",
              // miniBridge: "מיני ברידג'"
            }}
          />
          <img className="card-img1" src={DeffenceScreenClubCard} alt="img" />
          <img className="card-img2" src={DeffenceScreenHeartCard} alt="img" />
        </div>
      </div>
      {!showMobile && <MainFooterComponent />}
    </div>
  );
}

export default ByHandPlayExercise;
